import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../common/NavigationBar";
import Footer from "../common/Footer";
import ContactSection from "../common/ContactAs";

const TermsConditions = () => {
  const navigate = useNavigate();
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const offersRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handlePrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  return (
    <div className="terms-container">
      <NavigationBar
        homeRef={homeRef}
        aboutRef={aboutRef}
        servicesRef={servicesRef}
        offersRef={offersRef}
        contactRef={contactRef}
      />
      <section id="terms-conditions" className="terms-section">
        <h1>Terms & Conditions</h1>
        <div className="terms-header-content">
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <b>By submitting your details on this Website or through our mobile
              applications (Android/iOS) and requesting our Services, you hereby
              provide your express and voluntary written consent to
              RightLender.in, operated by Perukkal 100 Consultancy Private
              Limited (CIN: U66190TZ2024PTC031218), to act solely as a
              facilitator in connecting you with Banks, NBFCs, and lending
              partners for loan and credit-related services.</b>
            </p>
          </div>
        </div>
        
        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">Authorization</h4>
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <span className="terms-conditions-icon">●</span>
              You expressly acknowledge and agree that:
            </p>
            <ul className="terms-bullet-list">
              <li>
                <b>
                  RightLender does not check, fetch, or access your credit
                  report or score
                </b>{" "}
                from any Credit Bureau (including but not limited to CIBIL,
                Equifax, Experian, or CRIF Highmark).
              </li>
              <li>
                <b>Banks and NBFCs</b>, with whom you choose to proceed with an
                application, will independently obtain and review your credit
                report from their respective partnered Credit Bureaus as per
                their internal policies.
              </li>
              <li>
                RightLender’s role is limited to collecting basic application
                details provided by you and sharing them with lending partners
                to help identify suitable offers.
              </li>
              <li>
                RightLender does not guarantee approval of any loan or credit
                product, as such approvals are solely at the discretion of the
                respective Bank or NBFC.
              </li>
            </ul>
          </div>
        </div>

        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">Service</h4>
          <div className="terms-section-description">
            <ul className="terms-bullet-list terms-conditions-para">
              <li>
                RightLender provides a <b>facilitation service</b> to match you
                with Banks and NBFCs based on your profile.
              </li>
              <li>
                Obtaining your credit report is done{" "}
                <b>only by the Bank/NBFC</b> and not by RightLender.
              </li>
              <li>
                RightLender’s services are provided <b>free of cost</b> to
                users.
              </li>
            </ul>
          </div>
        </div>

        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">
            Information We Collect
          </h4>
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <span className="terms-conditions-icon">●</span>
              During registration and while using our Services, we may collect
              and process the following details solely for the purpose of
              facilitating your loan application:
            </p>
            <ul className="terms-bullet-list">
              <li>
                Name, Gender, Date of Birth, Contact Information (email, phone
                number)
              </li>
              <li>
                Banks and NBFCs, with whom you choose to proceed with an
                application, will independently obtain and review your credit
                report from their respective partnered Credit Bureaus as per
                their internal policies.
              </li>
              <li>PAN and Address</li>
              <li>Employment and Income details</li>
            </ul>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              <b>
                RightLender never directly collects or stores your Credit Bureau
                report/score.{" "}
              </b>
            </p>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              For more details, please refer to our{" "}
              <span className="nav-privacy-policy" onClick={handlePrivacyPolicy}>Privacy Policy</span>.
            </p>
          </div>
        </div>

        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">Eligibility</h4>
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <span className="terms-conditions-icon">●</span>
              To avail of the Services, you confirm that:
            </p>
            <ul className="terms-bullet-list">
              <li>
                You are at least 21 <b>years of age</b>;
              </li>
              <li>
                The information you provide is{" "}
                <b>true, accurate, current, and complete</b>;
              </li>
              <li>
                You are registering <b>only for yourself</b> and not on behalf
                of another individual;
              </li>
              <li>You will keep your information updated;</li>
              <li>
                You have registered voluntarily and without any
                misrepresentation by Right Lender.
              </li>
            </ul>
          </div>
        </div>

        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">Alerts</h4>
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <span className="terms-conditions-icon">●</span>
              Right Lender may provide a free{" "}
              <b>“Application Alerts” feature</b>, which will notify you (via
              SMS, email, WhatsApp, app notifications, or other channels) about
              the progress of your application as shared by the respective
              Bank/NBFC.
            </p>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              By availing this Service, you:
            </p>
            <ul className="terms-bullet-list">
              <li>
                Consent to receiving such alerts from Right Lender or its
                authorized service providers.
              </li>
              <li>
                Understand that credit-related alerts (such as bureau score
                updates) may come only from the Bank/NBFC and not directly from
                Right Lender.
              </li>
              <li>
                Agree not to hold Right Lender liable for the timing, accuracy,
                or availability of such alerts.
              </li>
            </ul>
          </div>
        </div>

        <div className="terms-header-content">
          <h4 className="highlight-color highlight-rate">
            Disclaimer & Limitation of Liability
          </h4>
          <div className="terms-section-description">
            <p className="terms-conditions-para">
              <span className="terms-conditions-icon">●</span>
              <b>
                Right Lender is not a bank, NBFC, financial institution, or
                Credit Bureau
              </b>
              . It only acts as a facilitator to connect you with lending
              partners.
            </p>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              Loan approval, rejection, interest rates, charges, processing
              timelines, and credit checks are entirely at the discretion of the
              respective <b>Bank/NBFC</b>.
            </p>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              Right Lender does not assure, guarantee, or promise that any user
              will receive a loan or credit facility.
            </p>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              Right Lender shall not be responsible or liable for:
            </p>
            <ul className="terms-bullet-list">
              <li>Decisions taken by Banks/NBFCs on your application;</li>
              <li>
                Accuracy, completeness, or updating of your credit information
                by Credit Bureaus;
              </li>
              <li>
                Any loss, damage, or claim arising out of your reliance on
                offers or information provided by Banks/NBFCs.
              </li>
            </ul>
            <p className="terms-conditions-paragraph">
              <span className="terms-conditions-icon">●</span>
              You agree that your engagement with Right Lender is at your sole
              discretion and risk, and that Right Lender’s liability (if any)
              shall be limited strictly to the extent of services availed on the
              Website or Mobile Apps.
            </p>
          </div>
        </div>
      </section>
      <ContactSection
        scrollToSection={scrollToSection}
        homeRef={homeRef}
        aboutRef={aboutRef}
        servicesRef={servicesRef}
        contactRef={contactRef}
        ref={contactRef}
      />
      <Footer />
    </div>
  );
};

export default TermsConditions;
